import { Link, useNavigate } from 'react-router-dom';

import logo from '@dmp/assets/icons/logo-colorful.svg';
import { Button } from '@dmp/components/ui/Button/Button';
import { ROUTE_PATHS } from '@dmp/constant/routePaths';
import { resetDatasetsState } from '@dmp/pages/DataCatalog/DataCatalog.store';
import { useGlobalStore } from '@dmp/stores';

import { UserDropdown } from '../../_share_/UserDropdown/UserDropdown';
import { EnvironmentSwitch } from './EnvironmentSwitch/EnvironmentSwitch';
import { LogoDropdown } from './LogoDropdown/LogoDropdown';

export const InternalAppLayoutHeader = () => {
  const navigate = useNavigate();
  const isLoggedIn = useGlobalStore((s) => s.isLoggedIn);

  const internalAppsPermission = useGlobalStore((s) => s.internalAppsPermission);

  const haveAccessToDatasetManagement = internalAppsPermission.dataset_management;

  const isDatasetManagementPage = location.pathname.includes('/internal-app/dataset-management');

  return (
    <div
      id="header"
      className="flex justify-between items-center py-[14px] px-4 bg-white rounded-[10px] mt-[12px] mb-[22px]"
    >
      <div className="flex justify-between gap-[10px] items-center">
        <LogoDropdown />
        <Link
          to={ROUTE_PATHS.LANDING_PAGE}
          className="brand-logo"
          onClick={(e) => {
            e.preventDefault();
            if (window.location.pathname === ROUTE_PATHS.LANDING_PAGE) {
              window.location.reload();
            } else {
              resetDatasetsState();
              navigate(ROUTE_PATHS.LANDING_PAGE);
            }
          }}
        >
          <img src={logo} alt="logo" className="h-[40px]" />
        </Link>
      </div>

      {isLoggedIn ? (
        <div className="flex items-center gap-[32px]">
          {haveAccessToDatasetManagement && isDatasetManagementPage && <EnvironmentSwitch />}

          <UserDropdown />
        </div>
      ) : (
        <div className="flex items-center gap-[10px]">
          <Button
            variant="primary"
            onClick={() => {
              navigate(ROUTE_PATHS.LOGIN);
            }}
          >
            Log In
          </Button>
          <Button onClick={() => navigate(ROUTE_PATHS.REGISTER)} className="hover:bg-[#5929D0]! hover:text-white!">
            Register
          </Button>
        </div>
      )}
    </div>
  );
};
